import { HttpErrorResponse } from '@angular/common/http';
import { ProvidersService } from './../../services/providers.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ProviderDetails } from 'src/app/models/provider-details';
import { FormGroup, FormControl } from '@angular/forms';
import { Language } from 'src/app/util/lang';


@Component({
  selector: 'app-choose-abonent',
  templateUrl: './choose-abonent.component.html',
  styleUrls: ['./choose-abonent.component.scss']
})

export class ChooseAbonentComponent implements OnInit {

  public providerDetail: ProviderDetails;
  public guid: string;
  public chooseAbonent: any; /// TODO  to make a model 
  public form: FormGroup;
  public showLoading: boolean = false;

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private providersService: ProvidersService) { }

  ngOnInit(): void { // TODO CREATE METHODS
    this.showLoading == true;
    this.form = new FormGroup({
      user: new FormControl()
    });
    this.activatedRoute.params.subscribe(params => {
      const { id } = params;
      this.guid = id;
    })
    if (!this.providersService.getProviderDetails().providerDetails) {
      this.router.navigate([`${Language.getCurrentLang()}/provider/${this.guid}`]);
    }
    else {
      let records = this.providersService.getProviderDetails().providerDetails.MultipleData;
      let data = [];
      let record;
      for (let i = 0; i < records.length; ++i) {
        record = records[i];
        let abonent = { /// TODO too make a model
          Items: [],
          Data: []
        };
        let items = [];
        for (let j = 0; j < 4; ++j) {
          items.push({ ProviderInputId: record[j][0], Value: record[j][1] })
        }
        abonent.Items = items;
        let rowData = [];
        for (let j = 4; j < record.length; ++j) {
          rowData.push(record[j]);
        }
        abonent.Data = rowData;
        data.push(abonent);
        this.chooseAbonent = data;

      }
      if (this.chooseAbonent.length === 1) {
        this.showLoading == true;
        this.providersService.checkProviderItemInputs(this.chooseAbonent[0].Items).subscribe(response => {
          if (response instanceof HttpErrorResponse || response.status === 400) {
            alert('Փորձեք մի փոքր ուշ'); // todo
          }
          else {
            this.providerDetail = response;
            this.router.navigate([`${Language.getCurrentLang()}/pay/${this.guid}`]);
          };
          this.showLoading == false;

        });
      }
    }
    this.showLoading == false;
  }


  public onSubmit() {
    const formData = this.form.getRawValue();
    this.showLoading == true;
    const { user } = formData;
    if (!user) {
      alert('Ընտրեք բաժանորդ'); // todo
    } else {
      this.providersService.checkProviderItemInputs(user).subscribe(response => {
        if (response instanceof HttpErrorResponse || response.status === 400) {
          alert('Փորձեք մի փոքր ուշ'); // todo
        }
        else {
          this.providerDetail = response;
          this.router.navigate([`${Language.getCurrentLang()}/pay/${this.guid}`]);
        };
      });
    }
    this.showLoading == false;
  }

}
